import i18n from "i18next";
import { initReactI18next } from "react-i18next";


import es from "./../public/locales/es.json";

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    // hi: { translation: hi },
    // fr: { translation: fr }
  },
  lng: "es", // default
  fallbackLng: ["es"],
  interpolation: { escapeValue: false }
});

export default i18n;
